module.exports = __webpack_public_path__ + "img/banner-comercio-mobile.68c15977.jpg";